export type EsToolCategory =
  | "Azar y Selección"
  | "Ruletas"
  | "Equipos y Grupos"
  | "Aula"
  | "Juegos y Dinámicas";

export interface EsToolMeta {
  slug: string;
  enSlug: string;
  name: string;
  tagline: string;
  category: EsToolCategory;
  icon: string;
  featured?: boolean;
  keywords: string[];
}

export const ES_CATEGORIES: EsToolCategory[] = [
  "Azar y Selección",
  "Ruletas",
  "Equipos y Grupos",
  "Aula",
  "Juegos y Dinámicas",
];

export const ES_TOOLS: EsToolMeta[] = [
  {
    slug: "selector-de-nombres",
    enSlug: "random-name-picker",
    name: "Selector de Nombres Aleatorios",
    tagline: "Elige un alumno o participante de forma justa con animación rápida.",
    category: "Azar y Selección",
    icon: "Shuffle",
    featured: true,
    keywords: ["selector de nombres", "sacar nombres aleatorios", "elegir nombre al azar", "sorteo de nombres"],
  },
  {
    slug: "selector-de-alumnos",
    enSlug: "random-student-picker",
    name: "Selector Aleatorio de Alumnos",
    tagline: "Ingresa tu lista de clase y elige un estudiante al azar con historial.",
    category: "Azar y Selección",
    icon: "GraduationCap",
    featured: true,
    keywords: ["selector de alumnos", "elegir estudiante al azar", "ruleta de alumnos gratis", "sacar alumno al azar"],
  },
  {
    slug: "ruleta-aleatoria",
    enSlug: "spin-the-wheel",
    name: "Ruleta Aleatoria Online",
    tagline: "Una vistosa ruleta de decisiones para elegir nombres, actividades y opciones.",
    category: "Ruletas",
    icon: "Disc3",
    featured: true,
    keywords: ["ruleta aleatoria", "girar la ruleta", "ruleta de decisiones", "ruleta interactiva online"],
  },
  {
    slug: "ruleta-de-nombres",
    enSlug: "wheel-of-names",
    name: "Ruleta de Nombres",
    tagline: "Escribe nombres y gira la ruleta para elegir un ganador de forma aleatoria.",
    category: "Ruletas",
    icon: "Disc3",
    featured: true,
    keywords: ["ruleta de nombres", "ruleta para sortear nombres", "sorteo de nombres ruleta", "generador de ruletas"],
  },
  {
    slug: "ruleta-si-o-no",
    enSlug: "yes-or-no-wheel",
    name: "Ruleta del Sí o No",
    tagline: "Ruleta giratoria de decisión 50/50 para resolver dudas al instante.",
    category: "Ruletas",
    icon: "HelpCircle",
    featured: true,
    keywords: ["ruleta si o no", "ruleta de si o no", "girar ruleta si o no", "decidir si o no"],
  },
  {
    slug: "ruleta-de-premios",
    enSlug: "prize-wheel",
    name: "Ruleta de Premios y Sorteos",
    tagline: "Gira la ruleta para entregar premios, recompensas e incentivos escolares.",
    category: "Ruletas",
    icon: "Gift",
    featured: true,
    keywords: ["ruleta de premios", "ruleta de la suerte premios", "ruleta para sorteos", "ruleta de recompensas"],
  },
  {
    slug: "ruleta-de-numeros",
    enSlug: "number-wheel",
    name: "Ruleta de Números Aleatorios",
    tagline: "Gira una ruleta con números del 1 al 100 o rangos personalizados.",
    category: "Ruletas",
    icon: "Hash",
    keywords: ["ruleta de numeros", "ruleta numerica", "girar numeros al azar"],
  },
  {
    slug: "ruleta-de-comida",
    enSlug: "food-wheel",
    name: "Ruleta de Qué Comer",
    tagline: "¿No sabes qué comer hoy? ¡Gira la ruleta de comida y decide al instante!",
    category: "Ruletas",
    icon: "Utensils",
    keywords: ["ruleta de comida", "que comer hoy ruleta", "que cenar ruleta", "elector de comida"],
  },
  {
    slug: "generador-de-equipos",
    enSlug: "team-generator",
    name: "Generador de Equipos Aleatorios",
    tagline: "Divide cualquier grupo o clase en equipos equilibrados con un solo clic.",
    category: "Equipos y Grupos",
    icon: "Users",
    featured: true,
    keywords: ["generador de equipos", "hacer equipos aleatorios", "crear grupos al azar", "dividir equipos"],
  },
  {
    slug: "creador-de-grupos",
    enSlug: "group-maker",
    name: "Creador de Grupos Aleatorios",
    tagline: "Crea grupos al azar según la cantidad de integrantes o número de grupos.",
    category: "Equipos y Grupos",
    icon: "UsersRound",
    keywords: ["creador de grupos", "armar grupos al azar", "generador de grupos"],
  },
  {
    slug: "generador-de-parejas",
    enSlug: "partner-generator",
    name: "Generador de Parejas Aleatorias",
    tagline: "Forma parejas al azar al instante, gestionando números impares automáticamente.",
    category: "Equipos y Grupos",
    icon: "Handshake",
    keywords: ["generador de parejas", "parejas al azar", "crear parejas aleatorias"],
  },
  {
    slug: "generador-de-numeros-aleatorios",
    enSlug: "random-number-generator",
    name: "Generador de Números Aleatorios",
    tagline: "Genera números al azar entre cualquier rango, únicos o repetidos.",
    category: "Azar y Selección",
    icon: "Hash",
    keywords: ["generador de numeros aleatorios", "numeros al azar", "sacar numero aleatorio"],
  },
  {
    slug: "dado-virtual",
    enSlug: "dice-roller",
    name: "Dado Virtual Online",
    tagline: "Lanza dados virtuales de 4 a 100 caras con animación realista.",
    category: "Juegos y Dinámicas",
    icon: "Dices",
    keywords: ["dado virtual", "lanzar dados online", "tirar dado aleatorio"],
  },
  {
    slug: "cara-o-cruz",
    enSlug: "coin-flip",
    name: "Lanzar Moneda Online (Cara o Cruz)",
    tagline: "Lanza una moneda virtual al aire y decide cara o cruz en un segundo.",
    category: "Juegos y Dinámicas",
    icon: "CircleDollarSign",
    keywords: ["cara o cruz", "lanzar moneda online", "tirar moneda al aire"],
  },
  {
    slug: "temporizador-para-clase",
    enSlug: "classroom-timer",
    name: "Temporizador para Clase y Aula",
    tagline: "Cuenta atrás gigante ideal para proyectores con tiempos predefinidos.",
    category: "Aula",
    icon: "Timer",
    featured: true,
    keywords: ["temporizador para clase", "cuenta atras escolar", "cronometro para aula"],
  },
  {
    slug: "plano-de-asientos",
    enSlug: "seating-chart",
    name: "Organizador de Asientos del Aula",
    tagline: "Distribuye asientos al azar en filas, parejas o grupos e imprímelo.",
    category: "Aula",
    icon: "LayoutGrid",
    keywords: ["organizador de asientos", "mapa de clase aleatorio", "distribuir alumnos en el aula"],
  },
  {
    slug: "ayudantes-del-aula",
    enSlug: "classroom-helper-picker",
    name: "Asignador de Ayudantes del Aula",
    tagline: "Asigna tareas escolares como encargado de fila, pizarra o material.",
    category: "Aula",
    icon: "Sparkles",
    keywords: ["ayudantes del aula", "encargados de clase", "tareas escolares asignacion"],
  },
  {
    slug: "selector-de-letras",
    enSlug: "random-letter-picker",
    name: "Selector de Letras Aleatorias",
    tagline: "Obtén letras del abecedario A–Z, vocales o consonantes al azar.",
    category: "Azar y Selección",
    icon: "Type",
    keywords: ["selector de letras", "letra aleatoria", "abecedario al azar"],
  },
  {
    slug: "generador-de-palabras",
    enSlug: "random-word-picker",
    name: "Generador de Palabras Aleatorias",
    tagline: "Bancos de palabras para ortografía, vocabulario y juegos.",
    category: "Azar y Selección",
    icon: "BookA",
    keywords: ["generador de palabras aleatorias", "palabras al azar", "palabras en español aleatorias"],
  },
  {
    slug: "tomador-de-decisiones",
    enSlug: "random-choice-picker",
    name: "Selector de Opciones Aleatorias",
    tagline: "Deja que la herramienta elija la opción adecuada de forma neutral.",
    category: "Azar y Selección",
    icon: "ListChecks",
    keywords: ["tomador de decisiones", "selector de opciones", "elegir al azar entre opciones"],
  },
  {
    slug: "si-o-no",
    enSlug: "yes-or-no-picker",
    name: "Selector Sí o No",
    tagline: "Una respuesta instantánea de sí, no o tal vez.",
    category: "Azar y Selección",
    icon: "CircleHelp",
    keywords: ["selector si o no", "si o no aleatorio", "respuesta si o no"],
  },
  {
    slug: "selector-de-colores",
    enSlug: "random-color-picker",
    name: "Selector de Colores Aleatorios",
    tagline: "Elige un color al azar con su nombre y código hexadecimal.",
    category: "Azar y Selección",
    icon: "Palette",
    keywords: ["selector de colores aleatorios", "color al azar", "generador de color hex"],
  },
  {
    slug: "generador-de-preguntas",
    enSlug: "random-question-picker",
    name: "Generador de Preguntas Aleatorias",
    tagline: "Preguntas de discusión y comprensión listas para usar.",
    category: "Azar y Selección",
    icon: "MessageCircleQuestion",
    keywords: ["generador de preguntas aleatorias", "preguntas para debatir", "preguntas al azar"],
  },
  {
    slug: "ruleta-de-la-suerte",
    enSlug: "lucky-wheel",
    name: "Ruleta de la Suerte",
    tagline: "Una ruleta divertida para sorteos, premios y sorpresas.",
    category: "Ruletas",
    icon: "Gift",
    keywords: ["ruleta de la suerte", "ruleta de la fortuna", "sorteo ruleta de la suerte"],
  },
  {
    slug: "ruleta-de-actividades",
    enSlug: "activity-wheel",
    name: "Ruleta de Actividades Escolares",
    tagline: "Gira para elegir la siguiente dinámica o ejercicio de la clase.",
    category: "Ruletas",
    icon: "Compass",
    keywords: ["ruleta de actividades", "actividades para clase ruleta", "dinamicas escolares"],
  },
  {
    slug: "ruleta-de-estudiantes",
    enSlug: "student-wheel",
    name: "Ruleta de Estudiantes",
    tagline: "Tu lista de alumnos colocada en una ruleta giratoria.",
    category: "Ruletas",
    icon: "UserRoundCheck",
    keywords: ["ruleta de estudiantes", "ruleta de alumnos", "sortear alumnos ruleta"],
  },
  {
    slug: "ruleta-de-decisiones",
    enSlug: "decision-wheel",
    name: "Ruleta de Decisiones",
    tagline: "Sí, no, tal vez o cualquier opción personalizada que agregues.",
    category: "Ruletas",
    icon: "Split",
    keywords: ["ruleta de decisiones", "tomar decisiones ruleta", "elegir opcion ruleta"],
  },
  {
    slug: "orden-de-fila",
    enSlug: "random-line-order",
    name: "Ordenador de Fila Aleatorio",
    tagline: "Organiza el orden de formación o fila de forma justa e imprimible.",
    category: "Equipos y Grupos",
    icon: "ListOrdered",
    keywords: ["orden de fila aleatorio", "ordenar alumnos en fila", "orden de turno al azar"],
  },
  {
    slug: "marcador-de-puntos",
    enSlug: "classroom-scoreboard",
    name: "Marcador de Puntos para Clase",
    tagline: "Lleva el cómputo de puntos por equipos en el proyector.",
    category: "Aula",
    icon: "Trophy",
    featured: true,
    keywords: ["marcador de puntos", "marcador escolar", "puntuacion por equipos"],
  },
  {
    slug: "encargados-de-clase",
    enSlug: "classroom-job-picker",
    name: "Selector de Encargados de Clase",
    tagline: "Asigna las responsabilidades del aula en un solo sorteo.",
    category: "Aula",
    icon: "ClipboardList",
    keywords: ["encargados de clase", "roles escolares", "responsabilidades del aula"],
  },
  {
    slug: "selector-de-actividades",
    enSlug: "activity-picker",
    name: "Selector de Actividades de Aprendizaje",
    tagline: "Ideas para calentamiento, trabajo en equipo y cierre de clase.",
    category: "Aula",
    icon: "Lightbulb",
    keywords: ["selector de actividades", "ideas para clases", "dinamicas educativas"],
  },
  {
    slug: "pausas-activas",
    enSlug: "brain-break-picker",
    name: "Generador de Pausas Activas",
    tagline: "Dinámicas cortas de movimiento y relajación para estudiantes.",
    category: "Aula",
    icon: "Wind",
    keywords: ["pausas activas", "descansos cerebrales", "brain breaks en español"],
  },
  {
    slug: "generador-de-mimica",
    enSlug: "charades-generator",
    name: "Generador de Palabras para Mímica",
    tagline: "Animales, profesiones, películas y acciones para actuar.",
    category: "Juegos y Dinámicas",
    icon: "Drama",
    featured: true,
    keywords: ["generador de mimica", "juego de mimica palabras", "charadas palabras"],
  },
  {
    slug: "generador-pictionary",
    enSlug: "pictionary-word-generator",
    name: "Generador de Palabras para Pictionary",
    tagline: "Palabras de fácil a difícil para dibujar y adivinar en grupo.",
    category: "Juegos y Dinámicas",
    icon: "Brush",
    keywords: ["generador pictionary", "palabras para dibujar", "pictionary en español"],
  },
  {
    slug: "que-prefieres",
    enSlug: "would-you-rather-generator",
    name: "Generador de ¿Qué Prefieres?",
    tagline: "Preguntas divertidas de dilemas para romper el hielo y debatir.",
    category: "Juegos y Dinámicas",
    icon: "Scale",
    keywords: ["que prefieres preguntas", "dilemas divertidos", "que prefieres juego"],
  },
  {
    slug: "preguntas-de-trivia",
    enSlug: "trivia-question-generator",
    name: "Generador de Preguntas de Trivia",
    tagline: "Preguntas de ciencia, historia, geografía y cultura general.",
    category: "Juegos y Dinámicas",
    icon: "Brain",
    keywords: ["preguntas de trivia", "trivia en español", "preguntas de cultura general"],
  },
  {
    slug: "generador-de-retos",
    enSlug: "random-challenge-generator",
    name: "Generador de Retos Aleatorios",
    tagline: "Desafíos escolares y dinámicas divertidas y seguras.",
    category: "Juegos y Dinámicas",
    icon: "Flame",
    keywords: ["generador de retos", "retos divertidos para niños", "desafios escolares"],
  },
];

export const getEsToolBySlug = (slug: string): EsToolMeta | undefined =>
  ES_TOOLS.find((t) => t.slug === slug || t.enSlug === slug);

export const getEnSlugForEsSlug = (esSlug: string): string => {
  const found = ES_TOOLS.find((t) => t.slug === esSlug || t.enSlug === esSlug);
  return found ? found.enSlug : esSlug;
};

export const getEsSlugForEnSlug = (enSlug: string): string => {
  const found = ES_TOOLS.find((t) => t.enSlug === enSlug || t.slug === enSlug);
  return found ? found.slug : enSlug;
};

export const relatedEsTools = (slug: string, count = 4): EsToolMeta[] => {
  const current = getEsToolBySlug(slug);
  const sameCategory = ES_TOOLS.filter((t) => t.slug !== current?.slug && t.category === current?.category);
  const others = ES_TOOLS.filter((t) => t.slug !== current?.slug && t.category !== current?.category);
  return [...sameCategory, ...others].slice(0, count);
};
